import { createBrowserRouter } from "react-router-dom";

import Root from "../components/root";
import Home from "../components/home";
import Login from "../components/login";
import Summary from "../components/summary";
import ErrorNotFound from "../components/Error/error-not-found";
import { HOME, SUMMARY } from "../constants/routes";
import ProtectedRoute from "./protected-route";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorNotFound />,
    children: [
      /* ---------- public ---------- */
      { index: true, element: <Login /> },
      /* ---------- protected ---------- */
      {
        element: <ProtectedRoute />,
        children: [
          { path: HOME,    element: <Home />    },
          { path: SUMMARY, element: <Summary /> },
        ],
      },
      { path: "*", element: <ErrorNotFound /> },
    ],
  },
]);

export default router;
